//web component for media height adjustment in slideshow banner
// Usage: <slideshow-banner></slideshow-banner>
class SlideshowBanner extends HTMLElement {
  constructor() {
    super();
    this.mediaContainer = this.querySelectorAll(".slideshow__media")[0];
  }
  connectedCallback() {
    this.adjustBannerMediaHeight();
    window.addEventListener("resize", this.adjustBannerMediaHeight.bind(this));
  }

  adjustBannerMediaHeight() {
    const textConainer = this.querySelectorAll(".slideshow__text")[0];
    const windowWidth = window.innerWidth;
    const textBoxHeight = textConainer.clientHeight + 36;
    if (
      windowWidth <= 749 &&
      this.mediaContainer &&
      this.mediaContainer.classList.contains("slideshow__banner--mobile-bottom")
    ) {
      this.mediaContainer.style.height = `calc(100% - ${textBoxHeight}px)`;
    } else {
      this.mediaContainer.style.height = "100%";
    }
  }
}
customElements.define("slideshow-banner", SlideshowBanner);
